export const DEPENDANT = "DEPENDANT";
export const SPOUSE = "SPOUSE";
export const PRIMARY = "PRIMARY";
export const CURRENT = "CURRENT";
export const ERROR_MSG = "Missing fields; Please re-check info";
export const REMINDER_MESSAGE = "Please save the patient data before progressing further";
export const DUPLICATE_DEPENDENT_ERROR_MESSAGE="Please remove duplicate patients"